<template>
  <div class="w_100per h_100per">
    <!-- 취소 팝업 -->
    <ConfirmYesNoV2 v-if="isOpenConfirmYesNo" @click-no="isOpenConfirmYesNo = false" @click-yes="onClickConfirmYes">
      <template #confirmmodal-title>정말 취소하시겠어요? </template>
      <template #confirmmodal-desc>
        지금 취소할 경우 <br />
        AI 로고송 생성내용은 저장되지 않습니다.
      </template>
    </ConfirmYesNoV2>
    <PageSlot :isflex="true">
      <template #pageslot-contents>
        <div class="max960-container aisonginfo-container">
          <div class="aisonginfo-loaderwrap">
            <CommonLoader v-if="status === 1 || !isEndVideo" />
            <img
              v-else-if="status === 2"
              class="complete-icon"
              src="/media/images/icon/changepassword-complete-icon.png"
              alt="changepassword-complete-icon"
            />
          </div>
          <h1 class="aisonginfo-title" v-html="title"></h1>
          <p class="aisonginfo-desc" v-html="desc"></p>
          <div class="video-wrap">
            <div class="goplay-btnwrap" v-if="status === 2 && isCompleteAiMusic && isEndVideo">
              <BasicButton @click-btn="goPlayer">
                <template #btnname>플레이어 바로가기</template>
              </BasicButton>
            </div>
            <div class="video-dim" v-if="status === 2 && isCompleteAiMusic && isEndVideo"></div>
            <video
              :src="videoInfo.videoUrl"
              ref="introduceVideo"
              class="video-box"
              autoplay
              muted
              @ended="onEnded"
            ></video>
          </div>
        </div>
      </template>
    </PageSlot>
  </div>
</template>
<script>
import PageSlot from '@/slot/PageSlot.vue';
import CommonLoader from '@/components/common/CommonLoader.vue';
import BasicButton from '@/components/BasicButton/BasicButton.vue';
import ConfirmYesNoV2 from '@/components/common/ConfirmYesNoV2.vue';
import {
  cancelGenerateMusicApi,
  checkGenerateMusicForActiveSpaceApi,
  getLogoSongApi,
  getVideoUrlForActiveSpaceApi
} from '@/service/api/mySoundApi';
import { getMySpaceInfoV2 } from '@/service/api/myMenuApi';
export default {
  components: {
    PageSlot,
    CommonLoader,
    BasicButton,
    ConfirmYesNoV2
  },
  async beforeRouteLeave(to, from, next) {
    const { name } = to;
    if (name === 'Main' && this.isClickBtn) {
      next();
    } else {
      this.isOpenConfirmYesNo = true;
    }
  },
  data() {
    return {
      isOpenConfirmYesNo: false,
      isClickBtn: false,
      isEndVideo: false,
      isWatchVideo: sessionStorage.getItem('isWatchVideo') ? parseInt(sessionStorage.getItem('isWatchVideo')) : -1,
      status: 1, // 1 : 로딩중 , 2: 완료
      isNeedPay: false, // 결제 필요 여부
      userId: this.$cookies.get('userId'),
      intervalId: -1,
      videoInfo: {
        videoId: null,
        videoUrl: null
      },
      isCompleteAiMusic: false,
      spaceName: null,
      aiSongMusicId: null,
      spacePayAt: null // 구독 상태
    };
  },
  async created() {
    if (this.isWatchVideo > -1) {
      this.isEndVideo = true;
    }
    if (this.$route.query) {
      const { spaceNm, name } = this.$route.query;
      this.spaceName = spaceNm;
      this.$store.commit('auth/setUserName', name);
    }
    await this.getMySpaceInfo();

    this.getVideoUrlForActiveSpace();
    this.checkGenerateMusicForActiveSpace(this.userId, this.$route.params.spaceid, this.$route.params.genmusicid);

    this.intervalId = setInterval(() => {
      this.checkGenerateMusicForActiveSpace(this.userId, this.$route.params.spaceid, this.$route.params.genmusicid);
    }, 1000 * 10);
  },
  methods: {
    onEnded() {
      this.isEndVideo = true;
      sessionStorage.setItem('isWatchVideo', 1);
      this.$refs.introduceVideo.play();
    },
    async onClickConfirmYes() {
      /* AI로고송 생성 취소  */
      cancelGenerateMusicApi(this.userId, this.$route.params.spaceid);
      this.isClickBtn = true;
      /*  쿠키 세팅 */
      this.$cookies.set('spaceId', this.$route.params.spaceid);
      /* 권한 세팅 */
      await this.$store.dispatch('auth/actionAuth');
      /* 로딩 추가 */
      this.$store.commit('player/setIsSkeltonLoading', true);
      /* 채널 생성 및 재생 */
      this.$store.dispatch('player/createNewChannel');
      /* CronTab 세팅  */
      this.$store.dispatch('cronjob/settingCronJob');
      /* 화면 이동 */
      sessionStorage.removeItem('isWatchVideo');
      this.$router.push({ path: '/main' });
    },
    /**
     * @description 내 스페이스 정보 조회
     */
    async getMySpaceInfo() {
      try {
        const { data } = await getMySpaceInfoV2(this.$route.params.spaceid, this.userId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          const { spacePayAt: spAt } = result;
          this.spacePayAt = spAt;
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getVideoUrlForActiveSpace() {
      try {
        const { data } = await getVideoUrlForActiveSpaceApi(this.userId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          this.videoInfo = result;
        } else {
          throw Error('getVideoUrlForActiveSpaceApi : ', resultCd);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async checkGenerateMusicForActiveSpace(userId, spaceId, genMusicId) {
      try {
        const { data } = await checkGenerateMusicForActiveSpaceApi(userId, spaceId, genMusicId);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          const { status, list } = result;
          if (status === 'SUCCESS' || status === 'TEXT_SUCCESS') {
            this.onCompleteAiMusic();
            const { streamAudioUrl } = list[0];
            this.aiSongMusicId = streamAudioUrl;
          }
        }
      } catch (error) {
        if (error.response) {
          const { data } = error.response;

          const { resultCd } = data;
          if (resultCd === '24001') {
            this.onCompleteAiMusic();
            this.getLogoSong();
          }
        }
        console.log(error);
      }
    },
    onCompleteAiMusic() {
      this.status = 2;
      this.isCompleteAiMusic = true;
      clearInterval(this.intervalId);
      this.intervalId = -1;
    },
    isDomainFormat(str) {
      const domainRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
      return domainRegex.test(str);
    },
    async goPlayer() {
      if (this.spacePayAt === 'T' || this.spacePayAt === 'Y') {
        this.isClickBtn = true;
        this.$store.commit('player/setSpaceCardInfo', { key: 'spaceNm', value: this.spaceName });
        /* 음원 중지 */
        this.$store.dispatch('pauseMusic');

        /*  쿠키 세팅 */
        this.$cookies.set('spaceId', this.$route.params.spaceid);
        /* 권한 세팅 */
        await this.$store.dispatch('auth/actionAuth');
        /* CronTab 세팅  */
        this.$store.dispatch('cronjob/settingCronJob');
        /* AI 뮤직 상태 변경  */
        this.$store.commit('player/setIsPlayAiMusicSong', true);
        this.$store.commit('player/setIsOpenAiMusicModal', true);
        /*  AI뮤직 재생 */
        if (this.isDomainFormat(this.aiSongMusicId)) {
          document.querySelector('video#aimusic_video').src = this.aiSongMusicId;
          document.querySelector('video#aimusic_video').play();
        } else {
          this.$BrandPlayer.playBrandMusic(this.aiSongMusicId);
          this.$BrandPlayer.onBrandPlay();
        }
        this.$store.commit('setPlay', true);

        sessionStorage.removeItem('isWatchVideo');
        /* 화면 이동 */
        this.$router.push({ path: '/main' });
      }
    },
    async getLogoSong() {
      try {
        const { data } = await getLogoSongApi(this.userId, this.$route.params.spaceid);
        const { resultCd, result } = data;
        if (resultCd === '0000') {
          const { brandMusicId } = result;
          this.aiSongMusicId = brandMusicId;
        } else {
          throw Error(resultCd);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async onClickBtn() {
      /*  쿠키 세팅 */
      this.$cookies.set('spaceId', this.$route.params.spaceid);
      /* 권한 세팅 */
      await this.$store.dispatch('auth/actionAuth');
      /* 로딩 추가 */
      this.$store.commit('player/setIsSkeltonLoading', true);
      /* 채널 생성 및 재생 */
      this.$store.dispatch('player/createNewChannel');
      /* CronTab 세팅  */
      this.$store.dispatch('cronjob/settingCronJob');
      /* 화면 이동 */
      this.$router.push({ path: '/main' });
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  computed: {
    title() {
      if (this.status === 1 || !this.isEndVideo) {
        return `내 공간을 더 특별하게 해줄 <br /> 플레이리스트를 만들고 있어요.`;
      } else {
        return `내 공간을 더 특별하게 해줄 <br /> 플레이리스트가 완성되었어요!`;
      }
    },
    desc() {
      if (this.status === 1 || !this.isEndVideo) {
        return `조금만 기다려주세요.`;
      }
      return `${this.spaceName}만을 위한 음악들을 감상해보세요.`;
    }
  }
};
</script>
<style scoped src="@/assets/css/aisonginfo/aisonginfo.css"></style>
